/*******************************************************************************

  Project: FIETSRENTAL
  Author:  WHAT.DIGITAL
  Date:    APRIL 2021

********************************************************************************/

(function ($) {
    "use strict";

    jQuery(document).ready(function ($) {
        $('.city_slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 12000,
            fade: false,
            prevArrow: $(".city_arrow_left"),
            nextArrow: $(".city_arrow_right"),
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },			
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },

                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                }
              ]
        });

        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
            disable: function () {
                var maxWidth = 800;
                return window.innerWidth < maxWidth;
            }

        });
    });

    $('.checkout_faq_head').click(function () {
        $(".checkout_faqs").toggleClass("active");
    });

	$("#change_city .mobile_city").removeClass("active");
	
	$('.mobile_city a').click(function () {
		$("#change_city .mobile_city").removeClass("active");
    });

	$(window).load(function() {
		setTimeout(function(){
			$(".selected-item").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/checkout_accordion.svg" />')

			$(".all-items > div:nth-child(2)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/checkout_accordion.svg" />')
			$(".all-items > div:nth-child(3)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/berlin_icon_2.svg" />')
			$(".all-items > div:nth-child(4)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/hamburg_icon_2.svg" />')
			$(".all-items > div:nth-child(5)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/munster_icon.svg" />')
			$(".all-items > div:nth-child(6)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/bremen_icon.svg" />')
			$(".all-items > div:nth-child(7)").prepend('<img src="https://dev-fietsrental.pantheonsite.io/wp-content/uploads/2021/04/osnabruc_icon.svg" />')
			
		}, 3000);			
	});
 
    $(function () {
        var header = $(".header_area");
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 10) {
                header.addClass("scrolled");
            } else {
                header.removeClass("scrolled");
            }
        });
    });

    $(".mainmenu ul li:has(ul)").addClass("has-submenu");
    $(".mainmenu ul li:has(ul.sub-menu)").addClass("small-submenu");
    $(".mainmenu ul li ul").addClass("sub-menu");
    $(".mainmenu ul.dropdown li").hover(function () {
        $(this).addClass("hover")
    }, function () {
        $(this).removeClass("hover")
    });

    var $menu = $("#menu"),
        $menulink = $("#spinner-form"),
        $menuTriggercont = $(".spinner-master"),
        $menuTrigger = $(".has-submenu > a"),
        $header_area = $(".header_area");
    $menulink.click(function (e) {
        $menulink.toggleClass("active");
        $menu.toggleClass("active");
        $menuTriggercont.toggleClass("active");
        $header_area.toggleClass("active");
    });

    $menuTrigger.click(function (e) {
        e.preventDefault();
        var t = $(this);
        t.toggleClass("active").next("ul").toggleClass("active")
    });

    $(".mainmenu ul li:has(ul)");
    function Tabs() {
        var bindAll = function () {
            var menuElements = document.querySelectorAll('[data-tab]');
            for (var i = 0; i < menuElements.length; i++) {
                menuElements[i].addEventListener('click', change, false);
            }
        }

        var clear = function () {
            var menuElements = document.querySelectorAll('[data-tab]');
            for (var i = 0; i < menuElements.length; i++) {
                menuElements[i].classList.remove('active');
                var id = menuElements[i].getAttribute('data-tab');
                document.getElementById(id).classList.remove('active');
            }
        }

        var change = function (e) {
            clear();
            e.target.classList.add('active');
            var id = e.currentTarget.getAttribute('data-tab');
            document.getElementById(id).classList.add('active');
        }

        bindAll();
    }

    var connectTabs = new Tabs();

	$(document).ready(function() {
		var customSelect = $(".custom_select");

		customSelect.each(function() {
			var thisCustomSelect = $(this),
				options = thisCustomSelect.find("option"),
				firstOptionText = options.first().html();

			var selectedItem = $("<div></div>", {
					class: "selected-item"
				})
				.appendTo(thisCustomSelect)
				.html(firstOptionText);

			var allItems = $("<div></div>", {
				class: "all-items all-items-hide"
			}).appendTo(thisCustomSelect);

			options.each(function() {
				var that = $(this),
					optionText = that.html();

				var item = $("<div></div>", {
						class: "item",
						on: {
							click: function() {
								var selectedOptionText = that.html();
								selectedItem.html(selectedOptionText).removeClass("arrowanim");
								allItems.addClass("all-items-hide");
							}
						}
					})
					.appendTo(allItems)
					.html(optionText);
			});
		});

		var selectedItem = $(".selected-item"),
			allItems = $(".all-items");

		selectedItem.on("click", function(e) {
			var currentSelectedItem = $(this),
				currentAllItems = currentSelectedItem.next(".all-items");

			allItems.not(currentAllItems).addClass("all-items-hide");
			selectedItem.not(currentSelectedItem).removeClass("arrowanim");

			currentAllItems.toggleClass("all-items-hide");
			currentSelectedItem.toggleClass("arrowanim");

			e.stopPropagation();
		});

		$(document).on("click", function() {
			var opened = $(".all-items:not(.all-items-hide)"),
				index = opened.parent().index();

			customSelect
				.eq(index)
				.find(".all-items")
				.addClass("all-items-hide");
			customSelect
				.eq(index)
				.find(".selected-item")
				.removeClass("arrowanim");
		});
	});

	$( document ).on( 'click', '.all-items > div', function( event ) {
		$(".selected-item").html($(this).html());
    })
	
}(jQuery));